/* MITOPDEAL header enhancements
 * 1. SHOP ALL CATEGORIES button injected into desktop nav
 * 2. Text logo styled as MITOP(black) + DEAL(red)
 * 3. Deals nav item forced to stay in flow (no right-float)
 */
(function () {
  'use strict';

  /* ── 1. SHOP ALL CATEGORIES button ─────────────────────────── */
  function injectCatsBtn() {
    var navUl = document.querySelector('[class*="ai-header-nav-container-"] > ul');
    if (!navUl || navUl.querySelector('.mtd-cats-li')) return;

    var li = document.createElement('li');
    li.className = 'mtd-cats-li';
    li.innerHTML =
      '<button class="mtd-cats-btn" type="button" aria-label="Shop all categories">' +
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"' +
      ' stroke="currentColor" width="18" height="18" aria-hidden="true">' +
      '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"' +
      ' d="M4 6h16M4 12h16M4 18h16"/></svg>' +
      'SHOP ALL CATEGORIES</button>';

    li.querySelector('.mtd-cats-btn').addEventListener('click', function () {
      var header = document.querySelector('[class*="ai-marketplace-header-"]');
      if (header && typeof header.openDrawer === 'function') {
        header.openDrawer();
        return;
      }
      var toggle = document.querySelector('[data-drawer-toggle]');
      if (toggle) toggle.click();
    });

    navUl.insertBefore(li, navUl.firstChild);
  }

  /* ── 2. Text logo: MITOP (black) + DEAL (red) ───────────────── */
  function styleTextLogo() {
    /* The block renders a <span> when no logo image is set */
    var logoWrap = document.querySelector('[class*="ai-header-logo-"] a');
    if (!logoWrap || logoWrap.dataset.mtdLogo) return;

    var span = logoWrap.querySelector('span');
    if (!span) return;

    var text = span.textContent.trim().toUpperCase();
    var idx  = text.indexOf('DEAL');
    if (idx === -1) {
      /* Fallback: assume last 4 chars are DEAL */
      idx = text.length - 4;
    }
    var before = text.slice(0, idx);
    var deal   = text.slice(idx);

    span.style.fontSize     = '26px';
    span.style.fontWeight   = '800';
    span.style.letterSpacing = '-0.02em';
    span.style.fontFamily   = 'var(--font-heading-family, sans-serif)';
    span.style.color        = '#111111';
    span.style.lineHeight   = '1';

    span.innerHTML =
      '<span style="color:#111111">' + before + '</span>' +
      '<span style="color:#e53e3e">' + deal   + '</span>';

    logoWrap.dataset.mtdLogo = '1';
  }

  /* ── 3. Fix: keep Deals in flow, not pushed to right ────────── */
  function fixNavAlignment() {
    var navUls = document.querySelectorAll('[class*="ai-header-nav-container-"] > ul');
    Array.prototype.forEach.call(navUls, function (ul) {
      ul.style.justifyContent = 'flex-start';
    });

    /* Remove any accidental margin-left:auto on highlighted items */
    var highlighted = document.querySelectorAll('[class*="ai-header-nav-link-"].highlighted');
    Array.prototype.forEach.call(highlighted, function (a) {
      a.style.marginLeft = '0';
    });
  }

  function run() {
    injectCatsBtn();
    styleTextLogo();
    fixNavAlignment();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', run);
  window.addEventListener('load', run);
})();
